import { render, staticRenderFns } from "./NavegacionModalCrud.vue?vue&type=template&id=435b1e5b&"
import script from "./NavegacionModalCrud.vue?vue&type=script&lang=ts&"
export * from "./NavegacionModalCrud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('435b1e5b', component.options)
    } else {
      api.reload('435b1e5b', component.options)
    }
    module.hot.accept("./NavegacionModalCrud.vue?vue&type=template&id=435b1e5b&", function () {
      api.rerender('435b1e5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Mantenedor/NavegacionModalCrud.vue"
export default component.exports